export const extractMentionedUserIds = (content: string): string[] => {
  if (!content) {
    return [];
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");

  return Array.from(
    new Set(
      Array.from(
        doc.body.querySelectorAll<HTMLElement>(
          'span[data-type="mention"][data-id]',
        ),
      )
        .map((element) => element.dataset["id"]?.trim() || "")
        .filter(Boolean),
    ),
  );
};
